"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const echain_shared_logging_1 = require("@igus/echain-shared-logging");
var QueueItemState;
(function (QueueItemState) {
    QueueItemState["Idle"] = "Idle";
    QueueItemState["Running"] = "Running";
    QueueItemState["Cancelled"] = "Cancelled";
})(QueueItemState || (QueueItemState = {}));
class Queue {
    constructor(isDebug = false) {
        this.isDebug = isDebug;
        this.className = 'Queue';
        this.queue = [];
        this.logger = (0, echain_shared_logging_1.getLogger)();
    }
    cancelAll() {
        this.queue.forEach((qi) => (qi.state = QueueItemState.Cancelled));
    }
    /**
     * adds an action into the queue
     */
    add(options, action) {
        const { name, cancel$ } = this.applyDefaultActionOptions(options);
        this.log(`${this.className}.add(${this.queue.length}, '${name !== null && name !== void 0 ? name : ''}'): called`);
        // create our new queue-item
        const queueItem = {
            name,
            action,
            subject: new rxjs_1.ReplaySubject(undefined),
            state: QueueItemState.Idle,
            cancel$,
        };
        // ..and add it to our queue
        this.queue.push(queueItem);
        // try to execute it right now
        this.processNextAction();
        // return corresponding observable to our callee :)
        return queueItem.subject.asObservable();
    }
    applyDefaultActionOptions(options) {
        const actionOptions = Object.assign({ name: undefined, cancel$: new rxjs_1.Subject() }, options);
        return actionOptions;
    }
    processNextAction() {
        var _a, _b;
        // get and check the next queued-item
        const queueItem = this.queue.find((qi) => qi.state === QueueItemState.Idle);
        if (!queueItem) {
            this.log(`${this.className}.next: nothing to do so..`);
            return;
        }
        // already something running?
        const curRunningQueueItem = this.queue.find((i) => i.state === QueueItemState.Running);
        if (curRunningQueueItem) {
            this.log(`${this.className}.next: some action is already running..`, (_a = curRunningQueueItem === null || curRunningQueueItem === void 0 ? void 0 : curRunningQueueItem.name) !== null && _a !== void 0 ? _a : '');
            return;
        }
        this.log(`${this.className}.next(${this.queue.length}, '${(_b = queueItem === null || queueItem === void 0 ? void 0 : queueItem.name) !== null && _b !== void 0 ? _b : ''}'): run!`);
        // mark as running
        queueItem.state = QueueItemState.Running;
        // run our action
        (0, rxjs_1.of)(undefined)
            .pipe(
        // 'execute' our action!
        (0, operators_1.mergeMap)(() => queueItem.action), 
        // if cancelled (maybe due to the clear method), do not emit something!
        (0, operators_1.filter)(() => queueItem.state !== QueueItemState.Cancelled), 
        // give the callee the chance to cancel the runner
        (0, operators_1.takeUntil)(queueItem.cancel$.pipe(
        // just change the state to cancelled
        (0, operators_1.tap)(() => (queueItem.state = QueueItemState.Cancelled)))), 
        // once done, finalize and finish it
        (0, operators_1.finalize)(() => {
            var _a;
            this.log(`${this.className}.finalize(${this.queue.length}, '${(_a = queueItem === null || queueItem === void 0 ? void 0 : queueItem.name) !== null && _a !== void 0 ? _a : ''}'):`, {
                wasCancelled: queueItem.state === QueueItemState.Cancelled,
            });
            this.finish(queueItem);
            // we need to de-couple the call-tree!
            // .. otherwise the order of subscribers is mixed up somehow
            // .. AND the most important, the callee's stream may call "finalize" which we are not aware of in our context
            setTimeout(() => this.processNextAction(), 0);
        }))
            // just forward all 'events' back into our subject
            .subscribe(queueItem.subject);
    }
    finish(queueItem) {
        var _a;
        this.log(`${this.className}.finish(${(_a = queueItem.name) !== null && _a !== void 0 ? _a : ''})`);
        // just to be sure..
        queueItem.subject.complete();
        // remove it from our queue
        const idxToRemove = this.queue.indexOf(queueItem);
        if (idxToRemove === -1) {
            this.logger.warn(`${this.className}.finish: item not found?! oO`, queueItem.name);
        }
        else {
            this.queue.splice(idxToRemove, 1);
        }
    }
    log(methodName, ...args) {
        if (!this.isDebug)
            return;
        this.logger.log(`${this.className}.${methodName}()`, ...args);
    }
}
exports.Queue = Queue;
//# sourceMappingURL=queue.js.map